import React from 'react';
import { formatLimitsUsd } from './ledgerUtils';
export const PortalWithdrawalFeeLimitNotice = ({ variant = 'page', netUsd = 0, feeUsd = 0, limitUsageUsd = 0, className = '', }) => {
    const hasExample = variant === 'modal' &&
        netUsd > 0 &&
        feeUsd > 0.0001 &&
        limitUsageUsd > netUsd + 1e-9;
    const title = variant === 'modal'
        ? 'Withdrawal fees count toward your limit.'
        : 'Fees count toward your withdrawal limit.';
    const body = hasExample ? (React.createElement(React.Fragment, null,
        "Your requested amount and all applicable fees are included in today's withdrawal usage. A",
        ' ',
        formatLimitsUsd(netUsd),
        " withdrawal with ",
        formatLimitsUsd(feeUsd),
        " in fees uses",
        ' ',
        formatLimitsUsd(limitUsageUsd),
        " of your limit.")) : variant === 'modal' ? (React.createElement(React.Fragment, null, "Your requested amount and all applicable fees are included in today's withdrawal usage.")) : (React.createElement(React.Fragment, null, "Your limit usage includes the withdrawal amount plus all applicable fees."));
    return (React.createElement("div", { className: `rounded-lg border border-amber-200 bg-amber-50 px-3 py-2.5 text-sm text-amber-950 ${className}`.trim(), role: "note" },
        React.createElement("p", { className: "font-semibold" }, title),
        React.createElement("p", { className: "mt-1 text-xs leading-snug text-amber-900/90" }, body)));
};
export default PortalWithdrawalFeeLimitNotice;
